//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { SyntheticEvent } from 'react'
import { logOT } from '@shared/loggingShared'

export function onPromise<T>(promise: (event: SyntheticEvent) => Promise<T>) {
  return (event: SyntheticEvent) => {
    if (promise) {
      promise(event).catch((error) => {
        logOT.debug('Unexpected error', error)
      })
    }
  }
}
